export const ROUTES = {
  HOME: "/",
  ABOUT: "/about",
  SERVICES: "/services",
  INDUSTRIES: "/about",
  PROJECTS: "/projects",
  CONTACT: "/contacts",
  MEDIA: "/media",
  GALLERY: "/gallery",
  CAREERS: "/careers",
  CLIENTS: "/clients",
  RECRUITMENT: "/services/manpower",
  MANPOWER: "/services/manpower",
  EQUIPMENT: "/equipment",
  AWARDS_AND_RECOGNITIONS: "/awards-and-recognitions",
  HSEQ: "/hseq",
  GWS: "/gws",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  COOKIE_POLICY: "/cookie-policy",
};

export const SERVICE_ROUTES = {
  hub: "/services",
  drilling: "/services/drilling",
  workover: "/services/workover-completion",
  om: "/services/oam",
  equipment: "/services/equipment",
  manpower: "/services/manpower",
};

export const AWARDS_AND_RECOGNITIONS_SECTIONS = {
  CERTIFICATIONS: "certifications",
  RECOGNITIONS: "industry-recognitions",
  OPERATIONAL_ACHIEVEMENTS: "operational-achievements",
  CORPORATE_CREDENTIALS: "corporate-credentials",
  TRUSTED_PARTNERS: "trusted-partners",
  COMPANY_PROFILE: "company-profile",
};

export const awardsAndRecognitionsSection = (section) =>
  `${ROUTES.AWARDS_AND_RECOGNITIONS}#${section}`;

export const serviceSection = (section) => {
  const map = {
    drilling: SERVICE_ROUTES.drilling,
    workover: SERVICE_ROUTES.workover,
    om: SERVICE_ROUTES.om,
    equipment: SERVICE_ROUTES.equipment,
    manpower: SERVICE_ROUTES.manpower,
  };
  return map[section] ?? `${ROUTES.SERVICES}?section=${section}`;
};
